import { LaunchScreenComponent, launchScreenComponentTemplate } from './LaunchScreen';
import styles from './LaunchScreen.styles.scss';
export const launchScreenDefinition = {
    baseName: 'launch-screen',
    template: launchScreenComponentTemplate,
    styles,
};
export const chameleonLaunchScreen = LaunchScreenComponent.compose(launchScreenDefinition);
